import React, { ReactNode } from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './InfoItem.module.scss';

type InfoItemProps = {
  title: string;
  description?: string;
  value?: ReactNode;
  indicator?: ReactNode;
};

const InfoItem = ({ title, description, value, indicator }: InfoItemProps) => {
  return (
    <div className={classes.container}>
      {/* always show indicator to save space, align relatively to the title */}
      <div className={classes.indicator}>{indicator}</div>
      <TitleWithDescription
        titleFont="body-14-bold"
        title={title}
        description={description && <p className={classes.description}>{description}</p>}
      />
      {value && <div className={classes.value}>{value}</div>}
    </div>
  );
};

export { InfoItem };
